import { once } from 'lodash';
import { retry } from '@wix/pricing-plans-utils/http';
import { type ControllerParams, IHttpClient } from '@wix/yoshi-flow-editor';
import { ViewerQueryParams } from '../constants';
import { EcomServerless } from '../services/ecom-serverless';
import { getInstallationState } from './isMultiPageApp';

type ErrorHandler = ControllerParams['flowAPI']['errorHandler'];
type WixCodeApi = ControllerParams['flowAPI']['controllerConfig']['wixCodeApi'];
type Location = WixCodeApi['location'];
// @ts-expect-error - ecom type is not exported
type Ecom = WixCodeApi['ecom'];
type AppParams = ControllerParams['flowAPI']['controllerConfig']['appParams'];

export interface ScrollToComp {
  shouldOpenCart: boolean;
  openSideCart: () => void;
}

export function buildOpenSideCart({
  location,
  ecom,
  onOpened,
}: {
  location: Location;
  ecom: Ecom;
  onOpened?: () => void;
}): ScrollToComp {
  const hasOpenCartQuery = !!location.query?.[ViewerQueryParams.openSideCart];
  const shouldOpenCart = hasOpenCartQuery;

  return {
    shouldOpenCart,
    openSideCart: () => {
      ecom.openSideCart();
      onOpened?.();
    },
  };
}

export const ECOM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';
export const ECOM_CART_ICON_WIDGET_ID = '1380bbc4-1485-9d44-4616-92e36b1ead6b';

export enum BiCheckoutVersion {
  PricingPlans = 'Pricing Plans',
  Ecom = 'ecom',
}

export const isViewerOnEcom = once(
  async (
    httpClient: IHttpClient,
    wixCodeApi: WixCodeApi,
    appParams: AppParams,
    errorHandler: ErrorHandler,
  ): Promise<boolean> => {
    const ecom = new EcomServerless(httpClient, errorHandler);
    const { hasRouter, isMpaPagesInstalled, isMpaEcomPagesInstalled } = await getInstallationState(
      wixCodeApi,
      appParams,
    );
    if (hasRouter) {
      if (isMpaEcomPagesInstalled && !isMpaPagesInstalled) {
        return true;
      }
      return retry({ times: 2, delay: 500, backoff: 1 }, () => ecom.isInPopulation()).catch(() => false);
    }
    return false;
  },
);
